<template>
  <v-container grid-list-xl>
    <v-layout wrap justify-space-between>
      <v-flex xs12 md12>
        <v-alert :value="alert" type="success">Başarıyla kaydedildi.</v-alert>
      </v-flex>
      
      <!-- Tenant Seçimi -->
      <v-flex xs12 md12>
        <v-card class="mb-4">
          <v-card-title class="pb-2">Tenant Seçimi</v-card-title>
          <v-card-text>
            <v-select
              v-model="selectedTenantId"
              :items="tenantOptions"
              item-text="tenantName"
              item-value="tenantId"
              label="Tenant Seç"
              @change="onTenantChange"
              dense
              outlined
            ></v-select>
          </v-card-text>
        </v-card>
      </v-flex>
      <v-flex xs12 md12>
        <v-flex xs12 md12>
          <v-switch
            v-model="discount.isAllProduct"
            @change="changeAllProduct"
            :label="`Ürünlerin Hepsini Seç: ${setState(discount.isAllProduct)}`"
          ></v-switch>
        </v-flex>
      </v-flex>
      <v-flex xs12 md12>
        <v-combobox
          v-model="select"
          :items="this.$store.getters['products/productCategories']"
          item-value="id"
          multiple
          @change="changeProduct"
          item-text="name"
          hide-details
          label="Ürün Seçiniz"
        ></v-combobox>
      </v-flex>
      <v-flex xs12 md12>
        <v-text-field
          v-model="discount.discountRate"
          label="İndirim Oranı (%)"
          :counter="max"
          required
          type="number"
          step="0.01"
          suffix="%"
        ></v-text-field>
      </v-flex>
      <v-flex xs12 md6>
        <v-menu
          v-model="menu2"
          :close-on-content-click="false"
          :nudge-right="40"
          transition="scale-transition"
          offset-y
          full-width
          min-width="290px"
        >
          <template v-slot:activator="{ on }">
            <v-text-field
              v-model="discount.startDate"
              label="Başlangıç Tarihi"
              prepend-icon="event"
              readonly
              v-on="on"
            ></v-text-field>
          </template>
          <v-date-picker
            v-model="discount.startDate"
            @input="menu2 = false"
          ></v-date-picker>
        </v-menu>
      </v-flex>
      <v-flex xs12 md6>
        <v-menu
          ref="menu3"
          v-model="menu3"
          :close-on-content-click="false"
          :nudge-right="40"
          :return-value.sync="time"
          transition="scale-transition"
          offset-y
          full-width
          max-width="290px"
          min-width="290px"
        >
          <template v-slot:activator="{ on }">
            <v-text-field
              v-model="discount.startTime"
              label="Başlangıç Saati"
              prepend-icon="access_time"
              readonly
              v-on="on"
            ></v-text-field>
          </template>
          <v-time-picker
            v-if="menu3"
            v-model="discount.startTime"
            full-width
            format="24hr"
            @click:minute="$refs.menu3.save(time)"
          ></v-time-picker>
        </v-menu>
      </v-flex>
      <v-flex xs12 md6>
        <v-menu
          v-model="menu1"
          :close-on-content-click="false"
          :nudge-right="40"
          transition="scale-transition"
          offset-y
          full-width
          min-width="290px"
        >
          <template v-slot:activator="{ on }">
            <v-text-field
              v-model="discount.endDate"
              label="Bitiş Tarihi"
              prepend-icon="event"
              readonly
              v-on="on"
            ></v-text-field>
          </template>
          <v-date-picker
            v-model="discount.endDate"
            @input="menu1 = false"
          ></v-date-picker>
        </v-menu>
      </v-flex>
      <v-flex xs12 md6>
        <v-menu
          ref="menu4"
          v-model="menu4"
          :close-on-content-click="false"
          :nudge-right="40"
          :return-value.sync="time"
          transition="scale-transition"
          offset-y
          full-width
          max-width="290px"
          min-width="290px"
        >
          <template v-slot:activator="{ on }">
            <v-text-field
              v-model="discount.endTime"
              label="Bitiş Saati"
              prepend-icon="access_time"
              readonly
              v-on="on"
            ></v-text-field>
          </template>
          <v-time-picker
            v-if="menu4"
            v-model="discount.endTime"
            full-width
            format="24hr"
            @click:minute="$refs.menu4.save(time)"
          ></v-time-picker>
        </v-menu>
      </v-flex>
      
      <!-- Gün Seçimleri -->
      <v-flex xs12 md12>
        <v-card class="pa-3" outlined>
          <v-card-title class="subtitle-1">Geçerli Günler</v-card-title>
          <v-layout row wrap>
            <v-flex xs12 md2>
              <v-checkbox v-model="discount.monday" :label="`Pazartesi`"></v-checkbox>
            </v-flex>
            <v-flex xs12 md2>
              <v-checkbox v-model="discount.tuesday" :label="`Salı`"></v-checkbox>
            </v-flex>
            <v-flex xs12 md2>
              <v-checkbox
                v-model="discount.wednesday"
                :label="`Çarşamba`"
              ></v-checkbox>
            </v-flex>
            <v-flex xs12 md2>
              <v-checkbox
                v-model="discount.thursday"
                :label="`Perşembe`"
              ></v-checkbox>
            </v-flex>
            <v-flex xs12 md2>
              <v-checkbox v-model="discount.friday" :label="`Cuma`"></v-checkbox>
            </v-flex>
            <v-flex xs12 md1>
              <v-checkbox
                v-model="discount.saturday"
                :label="`Cumartesi`"
              ></v-checkbox>
            </v-flex>
            <v-flex xs12 md1>
              <v-checkbox v-model="discount.sunday" :label="`Pazar`"></v-checkbox>
            </v-flex>
          </v-layout>
        </v-card>
      </v-flex>

      <v-flex xs12 md12>
        <v-switch
          v-model="discount.state"
          :label="`İndirim Durumu: ${setState(discount.state)}`"
        ></v-switch>
      </v-flex>
      
      <v-flex xs12>
        <v-btn color="success" @click="savediscount">Kaydet</v-btn>
        <v-btn color="primary" @click="goBack" class="ml-2">Geri</v-btn>
      </v-flex>
    </v-layout>
  </v-container>
</template>
<script>

export default {
  data: () => ({
    selectedTenantId: null,
    tenantOptions: [
      { tenantId: 1, tenantName: "Altinda Firsat" },
      { tenantId: 2, tenantName: "EAltin" }
    ],
    products: [],
    alert: false,
    allowSpaces: false,
    match: "Foobar",
    max: 0,
    select: [],
    date: new Date().toISOString().substr(0, 10),
    menu: false,
    menu1: false,
    time: null,
    menu2: false,
    menu3: false,
    menu4: false,
    model: "Foobar",
    discount: {
      state: true,
      monday: true,
      tuesday: true,
      wednesday: true,
      thursday: true,
      friday: true,
      saturday: true,
      sunday: true,
      discountRate: 0,
      isAllProduct: true
    },
  }),

  watch: {},

  methods: {
    onTenantChange() {
      if (this.selectedTenantId) {
        // LocalStorage'a tenant ID'yi kaydet
        localStorage.setItem('selectedTenantId', this.selectedTenantId.toString());
        localStorage.removeItem('selectedMpId'); // MpId'yi sıfırla
      }
    },
    changeProduct() {
      this.discount.isAllProduct = false;
    },
    changeAllProduct(categoryids) {
      if (categoryids) {
        this.select = this.$store.getters["products/productCategories"];
      } else {
        this.select = [];
      }
    },
    setState(state) {
      if (state) return "Aktif";
      return "Pasif";
    },
    async savediscount() {
      if (!this.selectedTenantId) {
        alert("Lütfen önce bir Tenant seçiniz!");
        return;
      }
      
      this.discount.discountRate = this.discount.discountRate;
      let discount = Object.assign({}, this.discount);
      discount.productIds = this.select.map((m) => m.id).join(",");
      
      try {
        if (this.discount.id)
          await this.$store.dispatch("discounts/putDiscount", discount);
        else 
          await this.$store.dispatch("discounts/postDiscount", discount);
        
        this.alert = true;
        
        setTimeout(() => {
          this.alert = false;
          this.goBack();
        }, 2000);
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error("Kayıt hatası:", error);
        alert("Kayıt sırasında hata oluştu: " + error.message);
      }
    },
    validateField() {
      this.$refs.form.validate();
    },
    resetValidation() {
      //   this.$refs.form.validate();
    },
    goBack() {
      this.$router.push('/admin/discount');
    }
  },
  computed: {},
  async mounted() {
    // Sayfa yüklendiğinde localStorage'dan tenant'ı al
    const savedTenantId = localStorage.getItem('selectedTenantId');
    // eslint-disable-next-line no-console
    console.log("Detail mounted - savedTenantId:", savedTenantId);
    
    if (savedTenantId && savedTenantId !== '0') {
      this.selectedTenantId = parseInt(savedTenantId);
    } else {
      // Eğer tenant seçili değilse, default olarak 1'i seç (edit sayfası için)
      if (this.$route.params.id) {
        this.selectedTenantId = 1; // Altinda Firsat
        localStorage.setItem('selectedTenantId', '1');
      }
    }

    if (this.$route.params.id) {
      await this.$store.dispatch(
        "discounts/getDiscount",
        this.$route.params.id
      );
      this.discount = this.$store.state.discounts.discount;
      this.discount.startDate = this.discount.startDate.substr(0, 10);
      this.discount.endDate = this.discount.endDate.substr(0, 10);
      this.discount.startTime = this.discount.startTime.substr(0, 5);
      this.discount.endTime = this.discount.endTime.substr(0, 5);
    }

    await this.$store.dispatch("products/getAllProducts");

    if (this.discount.productIds) {
      var ids = this.discount.productIds.split(",").map(Number);
      this.select = this.$store.getters["products/productCategories"].filter(
        (x) => ids.includes(x.id)
      );
    }
  },
  beforeDestroy() {
    // Sayfadan çıkarken localStorage'ı temizle
    localStorage.setItem('selectedTenantId', '0');
    localStorage.removeItem('selectedMpId');
  }
};
</script>
